import { Component, OnInit } from '@angular/core';
import { StoreService } from './../../../services/store.service';
import { ApiService } from './../../../services/api.service';
import { Profil } from './../../../models/Profil';
import { CommandeService } from './../../../services/commande.service';
import { SelectItem, Message, ConfirmationService, UIChart } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ThrowStmt } from '@angular/compiler';
import { ClientsService } from 'src/app/services/reporting/clients.service';
import { LocaliteService } from 'src/app/services/reporting/localites.service';
import { CriteriaData } from 'src/app/models/CriteriaData';
import { ReportingVenteService } from 'src/app/services/reporting/reporting.vente.service';
import { DatePipe } from '@angular/common';
import { ExcelService } from 'src/app/services/Excel.service';


@Component({
  selector: 'app-copdv',
  templateUrl: './copdv.component.html',
  styleUrls: ['./copdv.component.css']
})
export class CopdvComponent implements OnInit {

  titre = 'Co / PDV / Region';
  itemId: any;
  msgs: Message[] = [];

  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();

  dataBar: any;
  dataPie: any;


  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  listRegroupment: SelectItem[] = [];
  listLocalite: SelectItem[] = [];
  listLocalite2: SelectItem[] = [];
  listLocalite3: SelectItem[] = [];
  listLocalite4: SelectItem[] = [];

  selectedCodedz: string;
  selectedSousZone: string;
  selectedSecteur: string;
  selectedLocalitedd: string;
  selectedPdg: string;
  selectedMsisdn: string;
  selectedRegroupement: string;
  datedebut: any = new Date();
  datefin: any = new Date();

  itemsGlobal: any[] = [];
  itemsGlobal2: any[] = [];

  displayRegroupementDZ:boolean=true;
  displayRegroupementSOUSZONE:boolean=false;
  displayRegroupementSECTEUR:boolean=false;
  displayRegroupementLOCALITE:boolean=false;

  displaychargement:boolean;

  comrevendeur:number;
  compdg:number;
  revendeur : string;

  displayUserPartenaire:boolean;

  constructor(private confirmationService: ConfirmationService,
    private commandeService: CommandeService,
    private datePipe: DatePipe,
    private localiteService: LocaliteService,
    private clientsService: ClientsService,
    private reportingVenteService: ReportingVenteService,
    private excelService: ExcelService,
    private store: StoreService) { }

  ngOnInit() {
    this.loadSelectList();

    this.displayUserPartenaire = false;
    if(this.store.isUserPartenaire) {
      this.displayUserPartenaire = true;
    }

    //this.initChartBarre();
    //this.initChartPie();
  }


  async recherche() {
    if(this.selectedMsisdn === null || this.selectedMsisdn === undefined || this.selectedMsisdn === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un msisdn PDG ' });
      //return;
    }
    if(this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if(this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }
    
    let criteria: CriteriaData = new CriteriaData();
    criteria.codedz = this.selectedCodedz;
    criteria.souszone = this.selectedSousZone;
    criteria.secteur = this.selectedSecteur;
    criteria.localitedd = this.selectedLocalitedd;
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.revendeur = this.revendeur;
    criteria.regroupement = this.selectedRegroupement;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    criteria.horzone = "";
    console.log(JSON.stringify(criteria));

    this.displaychargement=true;
    try {
      this.itemsGlobal = <any>await this.reportingVenteService.venteOmyRevendeur(criteria).toPromise();  
    } catch (error) {}

    try {
      this.itemsGlobal2 = <any>await this.reportingVenteService.venteOmyRevendeur2(criteria).toPromise();  
    } catch (error) {}

    this.displaychargement=false;
    //console.log('itemsGlobal: ', this.itemsGlobal);

    this.comrevendeur=0;
    this.compdg=0;
    
    this.itemsGlobal.forEach(e => {
      this.compdg += Number(e.compdgin) + Number(e.compdgout);
      this.comrevendeur += Number(e.comrevendeurin) + Number(e.comrevendeurout);
    });

  }


  initChartBarre() {
    this.dataBar = {
      labels: ['Sabalibougou', 'Kalaban coro', 'Maganbougou', 'Hamdalaye', 'Bamako coura', 'ACI200', 'Kalaban coura', 'Sebenicore', 'Sabalibougou', 'Hamdalaye', 'Faladie', 'Sebenicore'],
      datasets: [
          {
              label: 'Vente Zone',
              backgroundColor: '#ff7e33',
              borderColor: '#ff7e33',
              data: [650000, 590000, 800000, 810000, 560000, 550000, 280000, 480000, 400000, 190000, 860000, 270000]
          },
          {
            label: 'Vente Hors Zone',
            backgroundColor: '#42A5F5',
            borderColor: '#42A5F5',
            data: [600000, 630000, 700000, 800000, 460000, 450000, 380000, 580000, 300000, 300000, 960000, 200000]
        }
      ]
    };

  }

  initChartPie() {
      this.dataPie = {
        labels: ['ZONE','HORS_ZONE'],
        datasets: [
            {
                data: [500000, 300000],
                backgroundColor: [
                    "#00A056",
                    "#FFCE56"
                ],
                hoverBackgroundColor: [
                    "#00A056",
                    "#FFCE56"
                ]
            }]
        };
    }


    async loadSelectList() {

      this.displayRegroupementDZ=true;
    this.displayRegroupementSOUSZONE=false;
    this.displayRegroupementSECTEUR=false;
    this.displayRegroupementLOCALITE=false;

      this.listLogin = [];
      if(this.store.isUserPartenaire) {
        this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
        this.selectedPdg = this.store.currentNomPDG;
      } else {
        this.listLogin.push({ label: 'PDG...', value: null });
        try {
          let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
          for (let el of dataRetourPdg) {
            this.listLogin.push({ label: el.login, value: el.login });
          }
        } catch (error) { }
      }
  
      this.listMsisdn = [];
      this.listMsisdn.push({ label: 'Msisdn...', value: null });
  
      this.listRegroupment = [];
      this.listRegroupment.push({ label: 'Niveau...', value: null });
      this.listRegroupment.push({ label: 'DZ', value: 'DZ' });
      this.listRegroupment.push({ label: 'Sous Zone', value: 'SOUSZONE' });
      this.listRegroupment.push({ label: 'Secteur', value: 'SECTEUR' });
      this.listRegroupment.push({ label: 'Code localité', value: 'LOCALITE' });
  
      try {
        this.listLocalite = [];
        this.listLocalite.push({ label: 'DZ...', value: null });
        let dataRetour = <any>await this.localiteService.findCodedz().toPromise();
        for (let el of dataRetour) {
          this.listLocalite.push({ label: el.codedz, value: el.codedz });
        }
      } catch (error) { }
  
      this.listLocalite2 = [];
      this.listLocalite2.push({ label: 'Sous zone...', value: null });
      this.listLocalite3 = [];
      this.listLocalite3.push({ label: 'Secteur...', value: null });
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
  
    }

    async onChangeRegroupement(event) {
      console.log("event======="+event);
      if(event === 'SOUSZONE'){
        this.displayRegroupementDZ=false;
        this.displayRegroupementSOUSZONE=true;
        this.displayRegroupementSECTEUR=false;
        this.displayRegroupementLOCALITE=false;
      } else if(event === 'SECTEUR'){
        this.displayRegroupementDZ=false;
        this.displayRegroupementSOUSZONE=false;
        this.displayRegroupementSECTEUR=true;
        this.displayRegroupementLOCALITE=false;
      } else if(event === 'LOCALITE'){
        this.displayRegroupementDZ=false;
        this.displayRegroupementSOUSZONE=false;
        this.displayRegroupementSECTEUR=false;
        this.displayRegroupementLOCALITE=true;
      } else {
        this.displayRegroupementDZ=true;
        this.displayRegroupementSOUSZONE=false;
        this.displayRegroupementSECTEUR=false;
        this.displayRegroupementLOCALITE=false;
      } 
    }
  
    async onChangeLocalite(event) {
      this.listLocalite2 = [];
      this.listLocalite2.push({ label: 'Sous zone...', value: null });
      let dataRet = <any>await this.localiteService.findCodeSousZone(event).toPromise();
      for (let el of dataRet) {
        this.listLocalite2.push({ label: el.codeSousZone, value: el.codeSousZone });
      }
      this.listLocalite3 = [];
      this.listLocalite3.push({ label: 'Secteur...', value: null });
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
    }
    async onChangeLocalite2(event) {
      this.listLocalite3 = [];
      this.listLocalite3.push({ label: 'Secteur...', value: null });
      let dataRet = <any>await this.localiteService.findCodeSecteur(event).toPromise();
      for (let el of dataRet) {
        this.listLocalite3.push({ label: el.codeSecteur, value: el.codeSecteur });
      }
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
    }
  
    async onChangeLocalite3(event) {
      this.listLocalite4 = [];
      this.listLocalite4.push({ label: 'Localite...', value: null });
      let dataRet = <any>await this.localiteService.findCodeLocalitedd(event).toPromise();
      for (let el of dataRet) {
        this.listLocalite4.push({ label: el.codeLocalitedd + ' - ' + el.localitedd, value: el.localitedd });
      }
    }
  
    async onChangePDG(event) {
      this.listMsisdn = [];
      this.listMsisdn.push({ label: 'Msisdn...', value: null });
      let dataRet = <any>await this.clientsService.findByLogin(event).toPromise();
      for (let el of dataRet) {
        this.listMsisdn.push({ label: el.telephone, value: el.telephone });
      }
    }
  
  
    localeDateString(val: any): any {
      if (val === null || val === undefined) {
        return null;
      }
      if (typeof val === 'string') {
        return val;
      } else {
        return this.datePipe.transform(val, "dd/MM/yyyy");
      }
    }

    async exporter() {
      if(this.itemsGlobal === null || this.itemsGlobal === undefined) {
        this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
        return;
      }
      if(this.itemsGlobal.length <= 0) {
        this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
        return;
      }
      const headers = [
        { name: 'PDG', key: 'pdg', display: true },
        { name: 'REGION', key: 'region', display: true },
        { name: 'SOUS ZONE', key: 'souszone', display: (this.displayRegroupementSOUSZONE || (this.displayRegroupementSECTEUR || this.displayRegroupementLOCALITE))},
        { name: 'SECTEUR', key: 'secteur', display: (this.displayRegroupementSECTEUR || this.displayRegroupementLOCALITE)},
        { name: 'LOCALITE', key: 'localitedd', display: true},
        { name: 'REVENDEUR', key: 'revendeur', display: true }, 
        { name: 'TYPE RESEAU', key: 'typereseau', display: true }, 
        { name: 'MONTANT CASH IN"', key: 'transactionin', display: true },
        { name: 'MONTANT CASH OUT', key: 'transactionout', display: true }, 
        { name: 'CA REALISATION', key: 'valeur', display: !this.displayUserPartenaire}, 
        { name: 'NOMBRE TRANSACTION (CASH IN)', key: 'nbtransactionin', display: true },
        { name: 'NOMBRE TRANSACTION (CASH OUT)', key: 'nbtransactionout', display: true },
        { name: 'COMMISSION PDG CASH IN', key: 'compdgin', display: true },
        { name: 'COMMISSION PDG CASH OUT', key: 'compdgout', display: true }];
        let listExportXLSX = [];
        listExportXLSX = [...this.itemsGlobal.map(entry => {
          const ret = {};
          for (const h of headers) {
            if (h.display) {
              ret[h.name] = entry[h.key];
            }
          }
          return ret;
        })
        ];

      if(this.displayUserPartenaire) {
        listExportXLSX = [...this.itemsGlobal.map(entry => ({
            "PDG": entry.pdg,
            "REGION": entry.region,
            "REVENDEUR": entry.revendeur,
            "TYPE RESEAU": entry.typereseau,
            "MONTANT CASH IN": entry.transactionin,
            "MONTANT CASH OUT": entry.transactionout,
            //"CA REALISATION": entry.valeur,
            "NOMBRE TRANSACTION (CASH IN)": entry.nbtransactionin,
            "NOMBRE TRANSACTION (CASH OUT)": entry.nbtransactionout,

            "COMMISSION PDV CASH IN": entry.comrevendeurin,
            "COMMISSION PDV CASH OUT": entry.comrevendeurout,
            "TOTAL COMMISSION PDV": entry.comrevendeurin + entry.comrevendeurout ,
            
            "COMMISSION PDG CASH IN": entry.compdgin,
            "COMMISSION PDG CASH OUT": entry.compdgout,
            "TOTAL COMMISSION PDG": entry.compdgin + entry.compdgout

          }))
        ];
      } else {
        listExportXLSX = [...this.itemsGlobal.map(entry => ({
            "PDG": entry.pdg,
            "REGION": entry.region,
            "REVENDEUR": entry.revendeur,
            "TYPE RESEAU": entry.typereseau,
            "MONTANT CASH IN": entry.transactionin,
            "MONTANT CASH OUT": entry.transactionout,
            "CA REALISATION": entry.valeur,
            "NOMBRE TRANSACTION (CASH IN)": entry.nbtransactionin,
            "NOMBRE TRANSACTION (CASH OUT)": entry.nbtransactionout,

            "COMMISSION PDV CASH IN": entry.comrevendeurin,
            "COMMISSION PDV CASH OUT": entry.comrevendeurout,
            "TOTAL COMMISSION PDV": entry.comrevendeurin + entry.comrevendeurout ,
            
            "COMMISSION PDG CASH IN": entry.compdgin,
            "COMMISSION PDG CASH OUT": entry.compdgout,
            "TOTAL COMMISSION PDG": entry.compdgin + entry.compdgout

          }))
        ];
      }
      
      this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.itemsGlobal.length + ' Ligne(s) trouvée(s)' });
    }



    async exporter2() {
      if(this.itemsGlobal2 === null || this.itemsGlobal2 === undefined) {
        this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
        return;
      }
      if(this.itemsGlobal2.length <= 0) {
        this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
        return;
      }
      let listExportXLSX = [];

      if(this.displayUserPartenaire) {
        listExportXLSX = [...this.itemsGlobal2.map(entry => ({
            "PDG": entry.pdg,
            //"REGION": entry.region,
            "REVENDEUR": entry.revendeur,
            "TYPE RESEAU": entry.typereseau,
            "MONTANT CASH IN": entry.transactionin,
            "MONTANT CASH OUT": entry.transactionout,
            //"CA REALISATION": entry.valeur,
            "NOMBRE TRANSACTION (CASH IN)": entry.nbtransactionin,
            "NOMBRE TRANSACTION (CASH OUT)": entry.nbtransactionout,

            "COMMISSION PDV CASH IN": entry.comrevendeurin,
            "COMMISSION PDV CASH OUT": entry.comrevendeurout,
            "TOTAL COMMISSION PDV": entry.comrevendeurin + entry.comrevendeurout ,
            
            "COMMISSION PDG CASH IN": entry.compdgin,
            "COMMISSION PDG CASH OUT": entry.compdgout,
            "TOTAL COMMISSION PDG": entry.compdgin + entry.compdgout

          }))
        ];
      } else {
        listExportXLSX = [...this.itemsGlobal2.map(entry => ({
            "PDG": entry.pdg,
            //"REGION": entry.region,
            "REVENDEUR": entry.revendeur,
            "TYPE RESEAU": entry.typereseau,
            "MONTANT CASH IN": entry.transactionin,
            "MONTANT CASH OUT": entry.transactionout,
            "CA REALISATION": entry.valeur,
            "NOMBRE TRANSACTION (CASH IN)": entry.nbtransactionin,
            "NOMBRE TRANSACTION (CASH OUT)": entry.nbtransactionout,

            "COMMISSION PDV CASH IN": entry.comrevendeurin,
            "COMMISSION PDV CASH OUT": entry.comrevendeurout,
            "TOTAL COMMISSION PDV": entry.comrevendeurin + entry.comrevendeurout ,
            
            "COMMISSION PDG CASH IN": entry.compdgin,
            "COMMISSION PDG CASH OUT": entry.compdgout,
            "TOTAL COMMISSION PDG": entry.compdgin + entry.compdgout

          }))
        ];
      }
      
      this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.itemsGlobal2.length + ' Ligne(s) trouvée(s)' });
    }




    aficherZone(val) {
      if (val === '' || val === null || val === undefined) {
        return "NON LOCALISE";
      }
      return val;
    }


}
